import type { SmartComboboxOption } from "../shared/smart-combobox";

type SkillGroup = { careers: string[]; skills: string[] };

const GROUPS: SkillGroup[] = [
  {
    careers: ["développeur", "informatique", "logiciel", "data", "web"],
    skills: [
      "JavaScript",
      "TypeScript",
      "React",
      "Vue.js",
      "Node.js",
      "Python",
      "SQL",
      "Git",
      "API REST",
      "Tests automatisés",
      "Docker",
      "Analyse de données",
    ],
  },
  {
    careers: ["marketing", "communication", "community"],
    skills: [
      "Stratégie marketing",
      "Community management",
      "SEO",
      "Publicité digitale",
      "Google Analytics",
      "Création de contenu",
      "Email marketing",
      "Étude de marché",
    ],
  },
  {
    careers: ["comptable", "finance", "contrôle", "banque"],
    skills: [
      "Comptabilité générale",
      "Analyse financière",
      "Contrôle de gestion",
      "Fiscalité",
      "Gestion budgétaire",
      "Excel avancé",
      "Sage",
      "Reporting financier",
    ],
  },
  {
    careers: ["commercial", "vente", "business"],
    skills: [
      "Prospection commerciale",
      "Négociation",
      "Gestion de portefeuille",
      "CRM",
      "Relation client",
      "Closing",
      "Présentation commerciale",
      "Service après-vente",
    ],
  },
  {
    careers: ["ressources humaines", "rh", "recrutement"],
    skills: [
      "Recrutement",
      "Gestion des talents",
      "Administration du personnel",
      "Droit du travail",
      "Paie",
      "Formation",
      "Gestion des conflits",
      "SIRH",
    ],
  },
  {
    careers: ["projet", "product", "manager"],
    skills: [
      "Gestion de projet",
      "Planification",
      "Agile",
      "Scrum",
      "Gestion des risques",
      "Leadership",
      "Coordination d’équipe",
      "Suivi budgétaire",
    ],
  },
];

const COMMON = [
  "Communication",
  "Travail en équipe",
  "Organisation",
  "Résolution de problèmes",
  "Autonomie",
  "Adaptabilité",
  "Gestion du temps",
  "Esprit d’analyse",
  "Leadership",
];

export const getSkillSuggestions = (headline: string): SmartComboboxOption[] => {
  const normalized = headline.toLowerCase();
  const contextual = GROUPS.filter((group) =>
    group.careers.some((career) => normalized.includes(career)),
  ).flatMap((group) => group.skills);
  return [...new Set([...contextual, ...COMMON, ...GROUPS.flatMap((group) => group.skills)])].map(
    (label) => ({ label, value: label }),
  );
};

export const LEVELS = [
  { value: 1, label: "Débutant" },
  { value: 2, label: "Intermédiaire" },
  { value: 3, label: "Autonome" },
  { value: 4, label: "Avancé" },
  { value: 5, label: "Expert" },
];
